import { useQuery } from '@tanstack/react-query';
import { fetchInstallationAccessState } from '../data/installations';
import useSessionStore from '../state/session';

export const INSTALLATION_ACCESS_QUERY_KEY = ['installation-access-state'] as const;

export function useInstallationAccess() {
  const sessionReady = useSessionStore(state => state.sessionReady);
  const authStatus = useSessionStore(state => state.authStatus);
  const query = useQuery({
    queryKey: INSTALLATION_ACCESS_QUERY_KEY,
    queryFn: () => fetchInstallationAccessState(),
    enabled: sessionReady && authStatus === 'authenticated',
    staleTime: 60_000,
    retry: false,
  });
  return {
    ...query,
    access: query.data ?? {
      accessMode: 'admin_only' as const,
      canAccess: false,
      canSeeEvents: true,
      isSales: false,
      isLocation032: false,
    },
  };
}
